import { ILLMProfilesState } from './types';
import initialState from '../store/initialState';
import {
  ADD_LLM_PROFILE,
  SET_LLM_PROFILES,
  SET_CURRENT_LLM_PROFILE,
  SET_LLM_PROFILE_CONFIRMED_BY_BACKEND,
  SET_LLM_PROFILE_STATE,
  DELETE_LLM_PROFILE,
  TOGGLE_LLM_PROFILE_FORM,
  UPDATE_LLM_PROFILE_FIELD,
  SET_LLM_PROFILE_FORM_ERRORS,
  RESET_LLM_PROFILE_FORM,
  LLMProfileActionTypes,
} from './types';

// Reducer function for managing LLM profiles state
export const llmProfilesReducer = (state: ILLMProfilesState = initialState.llmProfiles, action: LLMProfileActionTypes): ILLMProfilesState => {
  switch (action.type) {
    case ADD_LLM_PROFILE:
      // Add new llmProfile to the beginning of the list
      return {
        ...state,
        llmProfiles: [{ ...action.payload, updated_at: new Date().toISOString() }, ...state.llmProfiles],
      };

    case SET_LLM_PROFILES:
      // Replace the list of llmProfiles
      return {
        ...state,
        llmProfiles: [...action.payload],
        currentLLMProfileId: action.payload.length > 0 ? action.payload[0].profile_id : null,
      };

    case SET_CURRENT_LLM_PROFILE:
      // Update the current llmProfile ID
      return {
        ...state,
        currentLLMProfileId: action.payload,
      };

    case SET_LLM_PROFILE_CONFIRMED_BY_BACKEND:
      // Set llmProfile as no longer on route
      return {
        ...state,
        llmProfiles: state.llmProfiles.map((llmProfile) =>
          llmProfile.profile_id === action.profile_id ? { ...llmProfile, onroute: false, updated_at: action.updated_at } : llmProfile
        ),
      };

    case SET_LLM_PROFILE_STATE:
      // Find the llmProfile to update
      const updatedLLMProfile = state.llmProfiles.find((llmProfile) => llmProfile.profile_id === action.payload.profile_id);
      if (!updatedLLMProfile) {
        console.warn('LLMProfile not found when updating state', action.payload);
        return state;
      }

      return {
        ...state,
        llmProfiles: [
          // Put updated llmProfile first to maintain descending updated_at order
          { ...updatedLLMProfile, ...action.payload },
          ...state.llmProfiles.filter((llmProfile) => llmProfile.profile_id !== action.payload.profile_id),
        ],
      };

    case DELETE_LLM_PROFILE:
      // Remove llmProfile from the list
      const llmProfiles = state.llmProfiles.filter((llmProfile) => llmProfile.profile_id !== action.payload);
      return {
        ...state,
        llmProfiles,
        currentLLMProfileId: llmProfiles[0]?.profile_id || null,
      };

    case TOGGLE_LLM_PROFILE_FORM:
      // Toggle llmProfile form visibility
      return {
        ...state,
        showLLMProfileForm: action.payload,
      };

    case UPDATE_LLM_PROFILE_FIELD:
      // Update llmProfile form field
      return {
        ...state,
        llmProfileForm: {
          ...state.llmProfileForm,
          [action.payload.field]: action.payload.value,
          errors: {
            ...state.llmProfileForm.errors,
            [action.payload.field]: '',
          },
        },
      };

    case SET_LLM_PROFILE_FORM_ERRORS:
      // Update llmProfile form errors
      return {
        ...state,
        llmProfileForm: {
          ...state.llmProfileForm,
          errors: action.payload,
        },
      };

    case RESET_LLM_PROFILE_FORM:
      // Reset llmProfile form to initial state
      return {
        ...state,
        llmProfileForm: initialState.llmProfiles.llmProfileForm,
      };

    default:
      // Return state unchanged for unknown actions
      return state;
  }
};
